var _defs, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoteriaPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadow-card",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 6,
    stdDeviation: 4,
    floodColor: "#000000",
    floodOpacity: 0.4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "glow-coin",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "blur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cardBg1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E11D48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9F1239"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cardBg2",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#10B981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#047857"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "cardBg3",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F1F5F9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "coinGrad",
    cx: "30%",
    cy: "30%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FDE047"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#EAB308"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#A16207"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15, 10) rotate(-15 45 50)",
    filter: "url(#shadow-card)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 70,
    height: 90,
    rx: 4,
    fill: "url(#cardBg2)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 60,
    height: 80,
    rx: 2,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 45,
    r: 15,
    fill: "#FFFFFF",
    opacity: 0.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(35, 15) rotate(10 45 50)",
    filter: "url(#shadow-card)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 70,
    height: 90,
    rx: 4,
    fill: "url(#cardBg1)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 60,
    height: 80,
    rx: 2,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,25 L45,45 L25,45 Z",
    fill: "#FFFFFF",
    opacity: 0.3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25, 25)",
    filter: "url(#shadow-card)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 70,
    height: 90,
    rx: 4,
    fill: "url(#cardBg3)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 60,
    height: 80,
    rx: 2,
    fill: "none",
    stroke: "#0F172A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 31,
    x2: 65,
    y2: 31,
    stroke: "#0F172A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 58,
    x2: 65,
    y2: 58,
    stroke: "#0F172A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 5,
    x2: 35,
    y2: 85,
    stroke: "#0F172A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 18,
    r: 8,
    fill: "#E65100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,10 L58,10 L50,26 Z",
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 38,
    width: 16,
    height: 12,
    fill: "#8B5CF6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 44,
    r: 8,
    fill: "#F59E0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,65 L25,75 L15,75 Z",
    fill: "#10B981"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 65,
    width: 16,
    height: 12,
    fill: "#EC4899",
    rx: 2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow-card)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 65,
    cy: 55,
    rx: 12,
    ry: 8,
    fill: "url(#coinGrad)",
    transform: "rotate(-20 65 55)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,52 C54,58 65,65 76,60 L76,64 C65,69 54,62 54,56 Z",
    fill: "#A16207",
    transform: "rotate(-20 65 55)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 80,
    rx: 8,
    ry: 5,
    fill: "url(#coinGrad)",
    transform: "rotate(15 30 80)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 85,
    cy: 25,
    rx: 10,
    ry: 6,
    fill: "url(#coinGrad)",
    transform: "rotate(45 85 25)",
    filter: "url(#glow-coin)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78,20 C78,25 85,30 92,27 L92,30 C85,33 78,28 78,23 Z",
    fill: "#A16207",
    transform: "rotate(45 85 25)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoteriaPremium);
export default __webpack_public_path__ + "static/media/loteria_premium.48bacc3e5a8d751caad4c60da0956c86.svg";
export { ForwardRef as ReactComponent };